import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useApi, useAuth } from '@/contexts/AuthContext';

const SESSION_KEY = 'aira_visit_session';

const sessionId = () => {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
};

// One row per route change by a signed-in user → POST /visits (hash-chained `visits` collection).
// Never blocks navigation; a failed write is dropped silently.
export function useVisitTrail() {
  const api = useApi();
  const { user } = useAuth();
  const location = useLocation();
  const last = useRef('');

  useEffect(() => {
    if (!user || user === false) return;
    if (['regulator', 'investor'].includes(user.role)) return;   // read-only logins write nothing, not even a visit ping
    const path = location.pathname;
    if (path === last.current) return;
    last.current = path;
    api.post('/visits', { path, session_id: sessionId(), title: document.title || '', referrer: '' }).catch(() => {});
  }, [location.pathname, user, api]);
}
